import React, { useMemo, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPlus,
  faTrash,
  faFileInvoice,
  faTruck,
  faInbox,
} from '@fortawesome/free-solid-svg-icons';
import { CadastrosNotaProps } from './types';
import NotaModal from '../../../components/Cadastros/Notas/NotaModal';
import * as S from './styles';
import Table from '../../../components/interface/Tabela';
import { DateInput } from '../../../components/interface/DateInput';
import Filtros from '../../../components/interface/Filtros';
import BarraAcoes from '../../../components/interface/BarraAcoes';
import KpiCards from '../../../components/interface/KpiCards';
import EstadoVazio from '../../../components/interface/EstadoVazio';
import { dataPtBr } from '../../../utils/data';

const CadastrosNota: React.FC<CadastrosNotaProps> = ({
  selectedDate,
  error,
  notas,
  formData,
  entregadores,
  isModalOpen,
  handleDateChange,
  handleOpenModal,
  handleCloseModal,
  handleSubmit,
  handleChange,
  handleCancelarNota,
}) => {
  const [filtrosAbertos, setFiltrosAbertos] = useState(true);

  const totalEntregadores = useMemo(
    () => new Set(notas.map((nota) => nota.entregador)).size,
    [notas]
  );

  // trocar a data E a consulta desta tela: colapsa os filtros e devolve o
  // espaco para o resultado, como manda o padrao
  const aoTrocarData = (data: string) => {
    setFiltrosAbertos(false);
    handleDateChange(data);
  };

  return (
    <S.Container>
      {error && <S.ErrorMessage>{error}</S.ErrorMessage>}

      <Filtros
        aberto={filtrosAbertos}
        onToggle={() => setFiltrosAbertos((aberto) => !aberto)}
        badges={[`Data: ${dataPtBr(selectedDate)}`]}
      >
        <S.DateField>
          <DateInput
            initialValue={selectedDate}
            setValue={aoTrocarData}
            id="data"
            hasLabel={true}
            labelPosition="left"
            label="Data"
            required={true}
          />
        </S.DateField>
      </Filtros>

      <BarraAcoes rotulo="Ações das notas">
        <S.BotaoAcao onClick={() => handleOpenModal()}>
          <FontAwesomeIcon icon={faPlus} />
          <span>Nova nota</span>
        </S.BotaoAcao>
      </BarraAcoes>

      {notas.length > 0 && (
        <KpiCards
          itens={[
            { rotulo: 'Notas', valor: notas.length, icone: faFileInvoice },
            { rotulo: 'Entregadores', valor: totalEntregadores, icone: faTruck },
          ]}
        />
      )}

      {notas.length === 0 ? (
        <EstadoVazio
          icone={faInbox}
          titulo={`Nenhuma nota em ${dataPtBr(selectedDate)}`}
          // sem botao proprio: a barra de acoes fica logo acima e sempre
          // visivel, e dois botoes com o MESMO nome acessivel na mesma tela
          // deixam quem usa leitor de tela sem saber qual e qual
          descricao="Escolha outra data nos filtros ou use “Nova nota” para cadastrar a primeira do dia."
        />
      ) : (
        <Table
          data={notas}
          columns={[
            { key: 'chaveNota', header: 'Chave/Código', filterable: true },
            { key: 'entregador', header: 'Entregador', filterable: true },
            {
              key: 'actions',
              header: 'Excluir',
              width: '80px',
              td: (nota) => (
                <S.DeleteTableButton
                  onClick={() => handleCancelarNota(nota)}
                  title="Excluir nota"
                >
                  <FontAwesomeIcon icon={faTrash} />
                </S.DeleteTableButton>
              ),
            },
          ]}
          exportable={true}
        />
      )}

      <NotaModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        formData={formData}
        entregadores={entregadores}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
      />
    </S.Container>
  );
};

export default CadastrosNota;
